import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { User } from '../classes/user';
import { LoginService } from '../login/login.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

    constructor( private http: HttpClient, private loginService: LoginService ) { }
    
    getUser(): Observable<any> {
        const httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.loginService.getToken()}` } ) };
        
        return this.http.get<Object>( environment.apiGetuser , httpOptions )
            .pipe(
            tap( _ => console.log( 'fetched user' ) ),
            catchError( this.handleError( 'getUser', null ) )
            );
    }

    updateUser( user: User ): Observable<any> {
        const httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.loginService.getToken()}` } ) };
        return this.http.post(
            environment.apiUpdateuser,
            JSON.stringify( {
                user: user
            } ), httpOptions )
            .pipe(
            tap( _ => console.log( `updated User user=${user.user}` ) ),
            catchError( this.handleError( 'updateUser', null ) )
            );
        ;
    }

    createUser( user: User ): Observable<any> {
        const httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.loginService.getToken()}` } ) };
        return this.http.post(
            environment.apiCreateuser,
            JSON.stringify( {
                user: user
            } ), httpOptions )
            .pipe(
            // tap( _ => console.log( `Created User user=${user.user}` ) ),
            catchError( this.handleError( 'updateUser', null ) )
            );
        ;
    }
    
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>( operation = 'operation', result?: T ) {
        return ( error: any ): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error( error ); // log to console instead

            // TODO: better job of transforming error for user consumption
            // this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of( result as T );
        };
    }    
}
